// extracted by mini-css-extract-plugin
module.exports = {"title":"Confirm_title__Nt1E3","note":"Confirm_note__3Lmq7","list":"Confirm_list__1gEHz","btns":"Confirm_btns__LyK2X"};